export default __webpack_public_path__ + "static/media/delete-green.070aeb5a.svg";